<script>
  import { onMount } from 'svelte';
  import { headerDisplayStore, dialogStore, loadingStore } from '../stores/General';
  import { navigate } from 'svelte-navigator';
  import Table from '../components/table/Table.svelte';
  import Button from '../components/button/RouteButton.svelte';
  import { getList, remove } from '../api';

  let module_name = 'blacklist'
  let pageSize = 10;
  let data = [];
  let count = 0;
  let page = 1;
  let sortBy = 'created_at';
  let sortOrder = 'DESC';
  let filter = {};

  const getItems = () => {
    return [
      { value: 'newest', label: 'Newest' },
      { value: 'oldest', label: 'Oldest' },
    ];
  };

  let filters = [
    { label: 'Search Adomain', key: 'adomain', filter: 'text', value: '' },
    {
      label: '',
      key: 'sortByDate',
      filter: 'list',
      value: { label: 'Newest', value: 'newest' },
      getItems,
    },
  ];

  const columns = [
    { label: 'Publisher', key: 'publisher', filter: 'text', formatter: (pub) => pub?.name || '' },
    { label: 'Adomain', key: 'adomain', filter: 'text' },
    {
      label: 'Demand Partner',
      key: 'demand_partner',
      filter: 'text',
      formatter: (dp) => dp?.name || '',
    },
    { label: 'Approved', key: 'approved', view: 'boolean' },
    {
      label: '',
      key: 'action',
      actions: [
        { action: editAction, label: 'Edit', icon: 'edit' },
        { action: deleteAction, label: 'Delete', icon: 'dlt' },
      ],
    },
  ];

  function editAction(value) {
    navigate(`/blacklist/edit/${value.id}`);
  }

  const getBlacklist = async (pageSize, page, sortBy, sortOrder, filter) => {
    const { sortByDate, ..._filter } = filter;
    if (sortByDate === 'oldest') {
      sortOrder = 'ASC';
    } else if (sortByDate === 'newest') {
      sortOrder = 'DESC';
    }
    if (sortBy !== 'adomain') {
      sortBy = 'created_at';
    }
    return await getList(module_name, pageSize, page, sortBy, sortOrder, _filter);
  };
  
  function loadData() {
    data = [];
    loadingStore.on(module_name)
    getBlacklist(pageSize, page, sortBy, sortOrder, filter)
      .then((response) => {
        loadingStore.off(module_name)
        data = response.data;
        count = response.count;
      })
      .catch((error) => {
        loadingStore.off(module_name)
        headerDisplayStore.ShowError({
          title: 'Server error',
          subtitle: error?.message,
        });
      });
  }

  function onPageChange(event) {
    page = event.detail.page;
    pageSize = event.detail.pageSize;
    loadData();
  }

  function onSortChange(event) {
    sortBy = event.detail.sortBy;
    sortOrder = event.detail.sortOrder;
    loadData();
  }

  function onFilterChange(event) {
    const _filter = event.detail.filter;
    Object.keys(_filter).forEach((f) => {
      if (f) {
        const founded = filters.find((el) => {
          return el.key == f;
        });
        if (founded) founded.value = _filter[f] || '';
      }
    });
    filter = {};
    filters.forEach((f) => {
      if (
        (f.value && typeof f.value !== 'object') ||
        (typeof f.value === 'object' && (f.value.from || f.value.to))
      )
        filter[f.key] = f.value;
      else delete filter[f.key];
    });
    filter = filter;

    loadData();
  }
  function deleteSelected() {
    const selectedRows = data.filter((item) => item.selectedRow);
        dialogStore.openDeletePrompt(module_name,selectedRows,()=>{loadData()})
    }
    function deleteAction(value) {
      dialogStore.openDeletePrompt(module_name, [value], ()=>{loadData()})
    }

  onMount(() => {
    headerDisplayStore.SetTitle('Adomain Black-list');
    // onFilterChange always runs so we use its loadData()
  });
</script>

<div class="w-full sm:px-6 pb-2">
  <div class="pt-4 pr-4">
    <div class="sm:flex items-center justify-end">
      <div>
        <Button name="New Adomain Black-List" route="/blacklist/edit" />
      </div>
    </div>
  </div>
  <!-- <Table
    id="blacklist"
    {columns}
    {filters}
    bind:data
    {count}
    {pageSize}
    {page}
    {sortBy}
    {sortOrder}
    deleteAllButton={true}
    on:pageChange={onPageChange}
    on:sortChange={onSortChange}
    on:onFilterChange={onFilterChange}
    on:onDeleteSelected={deleteSelected}
  /> -->
</div>
